module.exports = __webpack_public_path__ + "static/assets/31185610d49e877f913168a64a9af2b8.gif";